import BaseService from "./BaseService.js";

class SupplyChainParticipantService extends BaseService {
  get() {
    return this.apiGet({
      url: "/scp",
    });
  }
  getData(query) {
    return this.apiGet({
      url: "/scp/data",
      params: query
    });
  }

  submit(payload) {
    return this.apiPost({
      url: "/scp",
      data: payload,
    });
  }
  getProfileData(query) {
    return this.apiGet({
      url: "/scp/profile",
      params: query
    });
  }

  submitProfile(payload) {
    return this.apiPost({
      url: "/scp/profile",
      data: payload,
    });
  }

  publish(scpId) {
    return this.apiPost({
      url: `/scp/${scpId}/publish`,
    });
  }
}

export default new SupplyChainParticipantService();
